import {Component, Input} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {

  @Input() description: string;

  constructor(protected ref: NbDialogRef<ConfirmDialogComponent>) {
  }

  dismiss(confirmed: boolean) {
    this.ref.close(confirmed);
  }

}
